/*
 * TransactionIdValue Messages
 *
 * This contains all the strings for the TransactionIdValue component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  // Transaction id link description
  desc:
    'Press on the link to check latest BTC Transaction detail from BlockChain.com in new tab.',
});
